<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<c-detail>
				<c-detail-item label="企业名称">
					{{private(userInfo.name)}}
				</c-detail-item>
				<c-detail-item label="单位性质">
					{{userInfo.user_type_name}}
				</c-detail-item>
				<c-detail-item label="营业执照号">
					{{private(userInfo.yyzzh)}}
				</c-detail-item>
				<c-detail-item label="法人姓名">
					{{private(userInfo.user_realname, 'name')}}
				</c-detail-item>
				<c-detail-item label="所属行业">
					{{userInfo.sshy}}
				</c-detail-item>
				<c-detail-item label="法人身份证号">
					{{private(userInfo.frsfz, 'idcard')}}
				</c-detail-item>
				<c-detail-item label="企业资质">
					{{userInfo.qyzz}}
				</c-detail-item>
				<c-detail-item label="联系电话">
					{{private(userInfo.phone, 'phone')}}
				</c-detail-item>
				<c-detail-item label="企业地址" full>
					{{userInfo.province_name}}{{userInfo.city_name}}{{userInfo.county_name}}{{userInfo.address}}
				</c-detail-item>
				<c-detail-item label="营业执照">
					<c-media :src="userInfo.yyzz_path"></c-media>
				</c-detail-item>
				<c-detail-item label="法人身份证头像面">
					<c-media :src="userInfo.frsfztx_path"></c-media>
				</c-detail-item>
				<c-detail-item label="资质证书">
					<c-media :src="userInfo.zzzs_path"></c-media>
				</c-detail-item>
				<c-detail-item label="法人身份证国徽面">
					<c-media :src="userInfo.frsfzgh_path"></c-media>
				</c-detail-item>
				<c-detail-item label="安全资质" full>
					<c-media v-if="userInfo.aqxkz_path" :src="userInfo.aqxkz_path"></c-media>
				</c-detail-item>
				
				<c-button slot="button" size="m" @click="navigateTo('/transact/user/edit')">修改资料</c-button>
			</c-detail>
		</menu-aside>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				userInfo: {}
			}
		},
		
		computed: {
			...mapGetters(['private'])
		},
		
		mounted() {
			this.request({
				url: '/user/cache',
				success: data => {
					this.userInfo = data;
				}
			});
		}
	}
</script>